import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import Logo from "../../assets/Logo.svg";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1 - Logo & tagline */}
        <div className="footer-col">
          <img src={Logo} alt="My Digital School" className="footer-logo-img" />
          {/* <p className="footer-tagline">
            Inspiring young minds with innovation and creativity.
          </p> */}
        </div>

        {/* Column 2 - Quick Links */}
        <div className="footer-col">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-list">
            <li><Link to="/about" className="footer-link">About</Link></li>
            <li><Link to="/#service" className="footer-link">Services</Link></li>
            <li><Link to="/#feature" className="footer-link">Features</Link></li>
            <li><Link to="/contact" className="footer-link">Contact</Link></li>
          </ul>
        </div>

        {/* Column 3 - Support */}
        <div className="footer-col">
          <h4 className="footer-heading">Support</h4>
          <ul className="footer-list">
            <li><Link to="/faq" className="footer-link">FAQ</Link></li>
            <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
            <li><Link to="/terms-of-condition" className="footer-link">Terms of Service</Link></li>
          </ul>
        </div>

        {/* Column 4 - Socials */}
        {/* <div className="footer-col">
          <h4 className="footer-heading">Follow Us</h4>
          <div className="footer-socials">
            <a href="#" aria-label="Facebook" className="social-icon">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#" aria-label="Twitter" className="social-icon">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" aria-label="Instagram" className="social-icon">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" aria-label="LinkedIn" className="social-icon">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div> */}
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} My Digital Schools. All rights reserved.</p>
      </div>
    </footer>
  );
}
